import { render, staticRenderFns } from "./lrs.vue?vue&type=template&id=bb1d5a6e"
import script from "./lrs.ts?vue&type=script&lang=js&external"
export * from "./lrs.ts?vue&type=script&lang=js&external"
import style0 from "./lrs.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports